<template>
	<div class="vedio-desc color-text2">
		<br>若您使用雲端硬碟連結將故事資料分享給我們，請將權限設定為：知道連結的人均可以檢視
		<br>
		<br>影片檔案命名規則
		<br>若貴組的故事名稱為：「改變世界我可以」，則請將影片命名為「改變世界我可以」
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.vedio-desc {
	padding-left: 10%;
	font-size: 14px;
}
</style>